(() => {
  if (customElements.get('tb-native-document')) return;
  class NativeDocument extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-native-document-content]');
      const nav = this.querySelector('.tb-document-contents');
      const list = this.querySelector('[data-document-links]');
      if (!content || !nav || !list) return;
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
      list.replaceChildren();
      headings.forEach((h, i) => {
        if (!h.id) h.id = `document-${this.dataset.sectionId}-${i}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.textContent = h.textContent.trim();
        link.setAttribute('href', '#' + encodeURIComponent(h.id));
        item.append(link); list.append(item);
      });
      nav.hidden = headings.length < 2;
      this.classList.toggle('has-contents', headings.length >= 2);
    }
  }
  customElements.define('tb-native-document', NativeDocument);
})();
